/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import DataBoxStackedAssociationComponent from './DataBoxStackedAssociationComponent';
import DataBoxAssociationComponent from './DataBoxAssociationComponent';

const DataBoxGroupingComponent = (props) => {
  const {
    stacked,
    grouping,
    expand,
    rememberState,
    boxID,
  } = props;
  let renderAssociations;
  if (stacked && grouping.associations.length === 1) {
    renderAssociations = props.grouping.associations.map(
      (a) => <DataBoxStackedAssociationComponent key={a.id} assoc={a} />,
    );
  } else {
    renderAssociations = props.grouping.associations.map((a, i) => {
      const open = expand
        || grouping.associations.length === 1
        || (rememberState && sessionStorage.getItem(`box-${boxID}-group-${grouping.id}-index-${i}`));
      return (
        <DataBoxAssociationComponent
          key={a.id}
          open={open}
          boxID={boxID}
          rememberState={rememberState}
          grouping={grouping.id}
          index={i}
          assoc={a}
        />
      );
    });
  }

  return (
    <div id={`box-${boxID}-grouping-${grouping.id}`}>
      {renderAssociations}
    </div>
  );
};

DataBoxGroupingComponent.defaultProps = {

};

DataBoxGroupingComponent.propTypes = {
  boxID: PropTypes.number.isRequired,
  stacked: PropTypes.bool.isRequired,
  expand: PropTypes.bool.isRequired,
  rememberState: PropTypes.bool.isRequired,
  grouping: PropTypes.shape({
    id: PropTypes.number.isRequired,
    associations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};

DataBoxGroupingComponent.displayName = 'DataBoxGroupingComponent';
export default DataBoxGroupingComponent;
